export default __webpack_public_path__ + "3fb2d242ba16aaebee430744d39299df.svg";